import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { useMediaQuery } from "@mui/material";

export default function DialogComp({ open, setOpen }) {
  const matches = useMediaQuery("(min-width:450px)");

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <React.Fragment>
      <Dialog
        sx={{
          ".MuiPaper-root": {
            borderRadius: matches ? "200px" : "200px",
            bgcolor: "#02276F",
          },
        }}
        maxWidth="md"
        open={open}
        onClose={handleClose}
      >
        <DialogContent>
          <div class="patterns">
            <svg
              width="80rem"
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <text x="50%" y="60%" text-anchor="middle">
                Coming Soon
              </text>
            </svg>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
